<mat-card id="cadastro">
    <mat-card-header>
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="300px">
          <h3>EXCLUIR EDITAL</h3>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      <p></p>

      <form [formGroup]="form"   class="formulario">

        <div fxLayout.align="center center" fxLayout.xs="column" fxLayoutGap="20px">

          <div class="form_linha" fxLayout.xs="column">
            <mat-form-field class="numero  campo_flex tamanho_100">
               <mat-label> Numero :</mat-label>
               <input matInput formControlName="numero" readonly >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="processo campo_flex tamanho_50">
              <mat-label>Processo:</mat-label>
              <input matInput formControlName="processo" readonly >
            </mat-form-field>

            <mat-form-field class="sei campo_flex tamanho_50">
              <mat-label>SEI:</mat-label>
              <input matInput formControlName="sei" readonly >
            </mat-form-field>

          </div>



          <div class="form_linha" fxLayout.xs="column">


            <mat-form-field class="data campo_flex tamanho_50">
              <mat-label>Data:</mat-label>
              <input matInput formControlName="data" readonly >
            </mat-form-field>

            <mat-form-field class="horario campo_flex tamanho_50">
              <mat-label>Horario:</mat-label>
              <input matInput formControlName="horario" mask="00:00" readonly >
            </mat-form-field>



          </div>
          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="modalidade campo_flex tamanho_50">
              <mat-label>Modalidade:</mat-label>
              <input matInput formControlName="modalidade" readonly >
            </mat-form-field>




            <mat-form-field class="agrupamento campo_flex tamanho_50">
              <mat-label>Agrupamento</mat-label>
              <input matInput formControlName="agrupamento" readonly >
            </mat-form-field>


          </div>



          <div class="form_linha" fxLayout.xs="column">



            <mat-form-field class="titulo campo_flex tamanho_100">
              <mat-label>Titulo:</mat-label>
              <input matInput formControlName="titulo" readonly>
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">
            <mat-form-field class="descricao campo_flex tamanho_100">
              <mat-label>Descricao:</mat-label>
              <input matInput formControlName="descricao" readonly >
            </mat-form-field>
          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="suspensa  campo_flex tamanho_25">
              <mat-label>Suspensa:</mat-label>
              <input matInput formControlName="suspensa" readonly>
            </mat-form-field>

          </div>



          <div class="form_linha" fxLayout.xs="column">
            <hr>
          </div>

           <div fxLayout="row" fxLayoutAlign="center center" class="titupload">
            E D I T A L 
          </div>

         


          <div class="form_linha" fxLayout.xs="column">

            <section class="campo_flex tamanho_100 flex_wrap">
              
              <div class="campo_flex tamanho_50" >

                <a href="{{caminhoArquivosUpload}}{{m_filename1}}" target="_blank">{{this.file1}}</a> 
 
              </div>
 
            </section>
          </div>




          <div fxLayoutAlign="center center" class="form_linha botoes">

            <button type="button" mat-raised-button name="retorna" color="warn" (click)="retorna()" >
              Retorna
            </button>


            <button type="button" mat-raised-button name="retorna" color="warn" (click)="retorna()" >
              Excluir
            </button>            
          </div>



        </div>

      </form>

    </mat-card-content>

  </mat-card>


